<div> <button mat-icon-button [mat-dialog-close]="{cancel: true}" class="close-dialog">
  <mat-icon>close</mat-icon>
</button>
<h2 mat-dialog-title> Update Outage </h2>
<div class="mat-dialog-title-content">
  <div class="scroll-container">
    <eca-form-column>
      <form [formGroup]="form">
        <mat-form-field>
          <mat-label>Title</mat-label>
          <input matInput formControlName="title" required>
          <mat-error>Title required</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Comment</mat-label>
          <textarea matInput formControlName="comment" required></textarea>
          <mat-error>Comment is required</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Client(s)</mat-label>
          <eca-multi-select [options]="clientList" formControlName="clients">
          </eca-multi-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Serivce(s)</mat-label>
          <eca-multi-select [options]="serviceList" formControlName="services">
          </eca-multi-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Status</mat-label>
          <mat-select disableOptionCentering formControlName="status" (selectionChange)="checkcommentRequired()">
            @for (opt of serviceStatusList; track opt) {
              <mat-option [value]="opt">
                {{opt}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Severity</mat-label>
          <mat-select disableOptionCentering formControlName="severity">
            @for (opt of serviceSeverityList; track opt) {
              <mat-option [value]="opt">
                {{opt}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    </eca-form-column>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="{cancel: true}"> Cancel </button>
  <button mat-button color="primary" [mat-dialog-close]="{cancel: false, form: form, serviceList: serviceList}"
  [disabled]="form.invalid"> Update </button>
</div>
</div>